import { ReactNode, createRef, useState } from "react"
import { AiOutlineMinusSquare, AiOutlinePlusSquare } from "react-icons/ai";
import styled from "styled-components"

interface CollapseProps {
  children: ReactNode[];
  background?: string;
  isFirst?: boolean;
}

export const Collapse = ({ children, background = '#fff', isFirst = true }: CollapseProps) => {
  const [isOpen, setIsOpen] = useState(false)
  const headRef: any = createRef();
  function click() {
    if (isOpen) {
      headRef?.current!.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
        inline: 'start',
      });
    }
    setIsOpen(!isOpen)
  }
  return (
    <Content ref={headRef} background={background} isOpen={isOpen}>
      <Body isOpen={isOpen}>
        {(!isOpen && !isFirst) &&
          <GradientBox isBottom={false}/>
        }
          {isOpen ? children[1] : children[0]}
        {(!isOpen) &&
          <GradientBox isBottom={true}/>
        }
      </Body>
      <BtnDiv>
        <CustomButton className="btn" onClick={() => click()}>
          {isOpen ? "Mostrar menos" : "  Mostrar mais"}
        </CustomButton>
      </BtnDiv>
    </Content>
  );
};

const Content = styled.div<{ background: string; isOpen: boolean }>`
  ${({ background }) => background && `background: ${background}`};
  transition: all 0.2s;

  @media screen and (max-width: ${({ theme }) => theme.device.tablet}) {
    margin-left: -14px;
    margin-right: -14px;
  }
`;

const Head = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 32px 48px;
  font-size: 38px;
  color: ${({ theme }) => theme.colors.blue.dark};
  cursor: pointer;

  @media screen and (max-width: ${({ theme }) => theme.device.tablet}) {
    font-size: 24px;
    padding: 16px 24px;

    svg {
      transform: scale(0.6) translateX(20px);
    }
  }
`;

const Body = styled.div<{ isOpen: boolean }>`
  position: relative;
  padding: 0 48px 32px;
  // opacity: ${({ isOpen }) => (isOpen ? 1 : 0)};
  // visibility: ${({ isOpen }) => (isOpen ? 'visible' : 'hidden')};
  transition: all 0.2s;

  * {
    font-size: 26px;
    color: ${({ theme }) => theme.colors.black.dark};
  }

  ul {
    padding-left: 16px;

    li {
      list-style-type: square;
      margin-bottom: 20px;

      &:last-child {
        margin-bottom: 0;
      }
    }
  }

  @media screen and (max-width: ${({ theme }) => theme.device.tablet}) {
    padding: 0 24px 16px;

    * {
      font-size: 18px;
    }

    > * {
      transform: translateY(-14px);
    }
  }
`;

const BtnDiv = styled.div`
  display: flex;
  padding: 0;
  position: relative;
  justify-content: center;
  flex-direction: column;
  margin-bottom: 32px;
`;

const CustomButton = styled.button`
  display: inline-block;
  font-size: 42px;
  padding: 0px 32px;
  color: ${({ theme }) => theme.colors.orange.medium};
  background-color: ${({ theme }) => theme.colors.blue.dark};
  margin: 0px auto;
  text-align: center;

  @media screen and (max-width: ${({ theme }) => theme.device.tablet}) {
    font-size: 32px;
    padding: 0px 20px;
    margin: 0px auto 20px;
  }
`;

const GradientBox = styled.div<{ isBottom: boolean }>`
  position: absolute;
  //height: 20%;
  top: ${({ isBottom }) => (isBottom ? '55%' : '0px')};
  bottom: ${({ isBottom }) => (!isBottom ? '80%' : '64px')};
  width: 100%;
  //padding: 0px;
  //margin-top: ${({ isBottom }) => (isBottom ? '-26%' : '0px')};
  background: linear-gradient(${({ isBottom }) => (isBottom ? '180deg' : '0deg')}, rgba(255,255,255,0) 0%, rgb(255, 255, 255) 100%);
`;
